import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from "react";
import Modal from '../../modal/Modal';
import { StateBootstrapButton as StateButton } from '../../forms/elements';
import * as UTIL from '../../../util';
import axios from 'axios';
import { Loading } from "../../state";
var addressValidationURL = UTIL.apiUtil.generateUrl('ups', 'validate-address');
export var AddressValidationModal = function AddressValidationModal(props) {
  var _props$addressValidat = props.addressValidation,
      addressValidation = _props$addressValidat === void 0 ? false : _props$addressValidat,
      _props$hideAddressVal = props.hideAddressValidate,
      hideAddressValidate = _props$hideAddressVal === void 0 ? function () {
    return "";
  } : _props$hideAddressVal,
      _props$setFieldValue = props.setFieldValue,
      setFieldValue = _props$setFieldValue === void 0 ? function () {
    return "";
  } : _props$setFieldValue,
      _props$handleRetail = props.handleRetail,
      handleRetail = _props$handleRetail === void 0 ? function () {
    return "";
  } : _props$handleRetail,
      retailIndex = props.retailIndex,
      values = props.values;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      selected = _useState2[0],
      setSelected = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      recommended = _useState4[0],
      setRecommended = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isLoading = _useState6[0],
      setLoading = _useState6[1];

  useEffect(function () {
    if (addressValidation) {
      var routeURL = addressValidationURL;
      setLoading(true);
      axios({
        method: 'post',
        headers: UTIL.apiUtil.setHeaders(),
        data: {
          AddressLine: [values.retailStreetAddress, values.retailStreetAddress2].filter(Boolean),
          PoliticalDivision2: values.retailCity,
          PoliticalDivision1: values.retailState,
          PostcodePrimaryLow: values.retailZip,
          CountryCode: "US"
        },
        url: routeURL
      }).then(function (res) {
        var _res$data, _res$data$XAVResponse;

        var addresses = (res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : (_res$data$XAVResponse = _res$data.XAVResponse) === null || _res$data$XAVResponse === void 0 ? void 0 : _res$data$XAVResponse.AddressKeyFormat) || {};
        var recs = Array.isArray(addresses) ? addresses : [addresses];
        setLoading(false);
        setRecommended(recs);
      }).catch(function (err) {
        setLoading(false);
        console.log(err, "ERR");
      });
    }
  }, [addressValidation]);

  var handleValidateAddress = function handleValidateAddress() {
    var selectedAddress = recommended[selected];
    var AddressLine = selectedAddress.AddressLine,
        PoliticalDivision1 = selectedAddress.PoliticalDivision1,
        PoliticalDivision2 = selectedAddress.PoliticalDivision2,
        PostcodePrimaryLow = selectedAddress.PostcodePrimaryLow,
        PostcodeExtendedLow = selectedAddress.PostcodeExtendedLow;

    try {
      if (Array.isArray(AddressLine)) {
        setFieldValue("retailStreetAddress", AddressLine[0]);
        setFieldValue("retailStreetAddress2", AddressLine[1]);
      } else {
        setFieldValue("retailStreetAddress", AddressLine);
      }

      setFieldValue("retailCity", PoliticalDivision2);
      setFieldValue("retailState", PoliticalDivision1);
      setTimeout(function () {
        // Delay zip code for UI paint issue
        setFieldValue("retailZip", "".concat(PostcodePrimaryLow) + '-' + "".concat(PostcodeExtendedLow));
      }, 10); // Throwing error on submission
      // ${(PostcodeExtendedLow) ? `-${PostcodeExtendedLow}` : ""}

      setTimeout(function () {
        // Delay zip code for UI paint issue
        handleRetail(retailIndex + 1, function () {
          return hideAddressValidate();
        });
      }, 20);
    } catch (e) {
      console.log(e, "CONSOLE");
    }
  };

  return /*#__PURE__*/React.createElement(Modal, {
    show: addressValidation,
    hide: function hide() {
      return hideAddressValidate();
    },
    title: "Address Validation"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, "To avoid delivery delays, please use the recommended shipping address."), recommended.map(function (add, index) {
    return /*#__PURE__*/React.createElement(RecommendedAddress, _extends({}, add, {
      index: index,
      key: "recommendedAddress-".concat(index),
      isActive: selected === index,
      onClick: function onClick() {
        setSelected(index);
      }
    }));
  }), /*#__PURE__*/React.createElement(Loading, {
    isLoading: isLoading
  }), !Boolean(recommended.length) && !isLoading && /*#__PURE__*/React.createElement("h2", {
    className: "cb-location-finder__no-locations"
  }, "No address found, please try a again"), /*#__PURE__*/React.createElement("div", {
    className: "cb-checkout__recommended-buttongroup"
  }, /*#__PURE__*/React.createElement(StateButton, {
    className: "cb-button-secondary mt-16",
    onClick: function onClick() {
      hideAddressValidate();
    }
  }, "Back"), /*#__PURE__*/React.createElement(StateButton, {
    className: "cb-button-primary mt-16",
    disabled: !recommended.length,
    onClick: function onClick() {
      handleValidateAddress();
    }
  }, "Continue"))));
};

var RecommendedAddress = function RecommendedAddress(_ref) {
  var AddressLine = _ref.AddressLine,
      index = _ref.index,
      Region = _ref.Region,
      CountryCode = _ref.CountryCode,
      isActive = _ref.isActive,
      onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("div", {
    className: "cb-checkout__recommendedaddress ".concat(isActive ? "is-active" : ""),
    onClick: onClick
  }, /*#__PURE__*/React.createElement("h2", {
    className: "cb-type-subheading-sm"
  }, "Recommended Address #", index + 1), /*#__PURE__*/React.createElement("p", null, Array.isArray(AddressLine) ? AddressLine.join(", ") : AddressLine), /*#__PURE__*/React.createElement("p", null, Region, " ", CountryCode));
};